const secureExternalLink = (anchor: HTMLAnchorElement) => {
  const url = new URL(anchor.href, window.location.href);
  const isWebLink = url.protocol === 'http:' || url.protocol === 'https:';

  if(!isWebLink || url.origin === window.location.origin) return;

  anchor.target = '_blank';
  anchor.relList.add('noopener', 'noreferrer');
};

const secureExternalLinksWithin = (root: HTMLElement) => {
  if(root instanceof HTMLAnchorElement && root.matches('a[href]')) secureExternalLink(root);
  root.querySelectorAll<HTMLAnchorElement>('a[href]').forEach(secureExternalLink);
};

export const manageExternalLinks = (root: HTMLElement) => {
  secureExternalLinksWithin(root);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(({addedNodes}) => {
      addedNodes.forEach((node) => {
        if(node instanceof HTMLElement) secureExternalLinksWithin(node);
      });
    });
  });

  observer.observe(root, {childList: true, subtree: true});

  return () => observer.disconnect();
};
